export class FailedToDeleteMappingError {

};
